// extracted by mini-css-extract-plugin
export default {"tooltip":"label-with-tooltip_tooltip__6UzF8"};